module.exports = __webpack_public_path__ + "img/26.946039a9.jpg";